import BaseModel from '@/api/RestModels/baseModel';
import api from './client';

class DocumentsRestModel extends BaseModel {
  path = 'documents';

  get = async (payload) => api.post(this.path, { json: payload, stream: true }).blob();
}

export default new DocumentsRestModel();
